import { useState, useEffect } from 'react';

export default function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-[#EEEEEE] shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex-1">
            <p className="text-sm text-[#333333]">
              Bu web sitesi, size en iyi deneyimi sunmak için çerezleri kullanır. 
              Sitemizi kullanmaya devam ederek çerez kullanımını kabul etmiş olursunuz.
              <a href="/gizlilik-politikasi" className="text-[#C41230] underline ml-1 hover:text-[#a00f28]">
                Daha fazla bilgi
              </a>
            </p>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={handleDecline}
              className="px-4 py-2 text-sm text-[#666666] hover:text-[#333333] transition-colors"
            >
              Reddet
            </button>
            <button
              onClick={handleAccept}
              className="px-6 py-2 bg-[#C41230] text-white text-sm font-medium rounded-lg hover:bg-[#a00f28] transition-colors"
            >
              Kabul Et
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}